<template>
  <div id="detail">
    <div slot="table-busy" class="text-center text-gold my-2" v-if="isBusy">
      <b-spinner class="align-middle"></b-spinner>
      <strong>{{$t("Chargement")}} ...</strong>
    </div>
    <div v-if="!isBusy">
      <div class="row mb-4">
        <div class="col-md-7">
          <EvaluationSumLine v-model="datas" :rights="rights"></EvaluationSumLine>
        </div>
        <div class="col-md-5 text-right pt-3">
          <a href="javascript:void(0)" @click="rapport_get()" class="btn btn-gold xs" right :disabled="!this.datas.hasRapport" v-if="rights.see_rapport"><span v-if="this.datas.hasRapport">{{$t("Télécharger le rapport")}}</span><span v-else>{{$t("Rapport en cours de génération")}} <b-spinner class="align-middle"></b-spinner></span></a>
          <a href="javascript:void(0)" @click="facture_get()" class="btn btn-gold xs ml-3" right v-if="this.datas.trans==3 && rights.see_facture">{{$t("Télécharger la facture")}}</a> 
        </div>
      </div>
      <b-tabs nav-wrapper-class="bg-dark ooftop-tabs" align="center" v-model="tabs">
        <b-tab lazy v-if="rights.rapport.synthese" :title="$t('Synthèse')">
          <div class="noverflow">
            <EvaluationStreetview v-model="datas" :gmapkey="gmap_key" :rights="rights" :seuilAna="infos_cli.seuil_ana" @enregSuccess="enregSuccess" @enregFailed="enregFailed"></EvaluationStreetview>
            <EvaluationPF v-model="datas" :ooftopMapApi="ooftopMapApi" :ooftopMapApiKey="ooftopMapApiKey" :rights="rights" v-if="rights.rapport.synthese_pf" :color="partner.code=='BNPPF'?'rgb(23, 150, 104) ':'rgb(234, 100, 84)'"></EvaluationPF>
          </div>
        </b-tab>
        <b-tab lazy v-if="rights.rapport.eval_prix" :title="$t('Evaluations prix')">
          <EvaluationPrix v-model="datas" :gmapkey="gmap_key" :rights="rights"></EvaluationPrix>
        </b-tab>
        <b-tab lazy :title="$t('Bien vendus')" v-if="rights.rapport.marche_immo && rights.rapport.marche_immo_bien_vendus" >
          <EvaluationTransactions v-if="rights.rapport.marche_immo && rights.rapport.marche_immo_bien_vendus" v-model="datas" :ooftopMapApi="ooftopMapApi" :ooftopMapApiKey="ooftopMapApiKey" :rights="rights" @enregSuccess="enregSuccess" @enregFailed="enregFailed"></EvaluationTransactions>
        </b-tab>
        <b-tab lazy v-if="rights.rapport.quartier" :title="$t('Le quartier')">
          <EvaluationQuartier v-model="datas" :ooftopMapApi="ooftopMapApi" :ooftopMapApiKey="ooftopMapApiKey" :rights="rights"></EvaluationQuartier>
        </b-tab>
        <b-tab lazy v-if="rights.rapport.risques" :title="$t('Risques')">
          <EvaluationRisques v-model="datas" :ooftopMapApi="ooftopMapApi" :ooftopMapApiKey="ooftopMapApiKey" :rights="rights"></EvaluationRisques>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import $Scriptjs from 'scriptjs';
  import EvaluationPrix from '@/components/Evaluations/EvaluationPrix'
  import EvaluationSumLine from '@/components/Evaluations/EvaluationSumLine'
  import EvaluationTransactions from '@/components/Evaluations/EvaluationTransactions'
  import EvaluationQuartier from '@/components/Evaluations/EvaluationQuartier'
  import EvaluationRisques from '@/components/Evaluations/EvaluationRisques'
  import EvaluationStreetview from '@/components/Evaluations/EvaluationStreetview'
  import EvaluationPF from '@/components/Evaluations/EvaluationPF'
  export default {
    components: { EvaluationPrix,EvaluationSumLine,EvaluationTransactions,EvaluationQuartier,EvaluationRisques,EvaluationStreetview,EvaluationPF },
    data() {
      return {
        isBusy: true,
        tabs:0,
        hasRapport: false,
        nodata:this.$i18n.t('Données insuffisantes'),
        gmap_key:'AIzaSyDGc_oBNLZF6jhV6OmZxDArFxAnPgPOmA0',
        rights:[],
        ooftopMapApi:'',
        ooftopMapApiKey:'',
        datas:{}
      };
    },
    methods:{
      enregSuccess(message){
        this.load_dossier(0);
        this.infosModal('success',message,false,'Confirmation');
      },
      enregFailed(message){
        this.infosModal('warning',message,false,'Informations');
      },
      rapport_get() {
        if(!this.datas.hasRapport)this.infosModal("warning", this.$i18n.t("Le téléchargement du rapport en pdf est indisponible pour le moment. Veuillez nous excuser pour la gêne occasionnée"), false, 'Informations');
        else window.open(this.$apiUrl+"demandes/rapport/"+this.idpage+"?lang="+this.$i18n.locale+"&auth="+JSON.stringify(this.auth_header()));
      },
      facture_get(){
        window.open(this.$apiUrl+'demandes/getDoc/facture/'+this.datas.id+'?auth='+JSON.stringify(this.auth_header()));
      },
      load_dossier(generate){
        var p=this;
        axios.get(p.$apiUrl+"demandes/detail/"+p.idpage ,{params : {auth:p.auth_header(),lang:p.$i18n.locale}}).then(response => {
          if(response.data.error=='notlogged'){
            p.logout();
            p.$router.push({ path: '/' });
          }
          if (response.data.datas) {
            p.datas = response.data.datas;
            p.rights = response.data.right;
            p.ooftopMapApiKey = (response.data['ooftop-token'] || {}).token || '';
            p.isBusy=false;
            if(p.datas.code_postal.substring(0,2)=='58' || p.datas.code_postal.substring(0,2)=='67' || p.datas.code_postal.substring(0,2)=='68')p.nodata='pour ce département les données ne sont pas disponibles';
            if(generate)axios.get(p.$apiUrl+"demandes/rapport/"+p.idpage+"?lang="+p.$i18n.locale+"&generate=1&auth="+JSON.stringify(p.auth_header())).then(response => {p.datas.hasRapport=true;})
            $Scriptjs('https://maps.googleapis.com/maps/api/js?key='+p.gmap_key+'&callback=Function.prototype', () => {
            });
          } else {
              this.show_alert("warning","Pas de données disponible");
          }
        }).catch(error => {});
      }
    },
    mounted() {
      this.idpage = this.$route.params.id;
      this.ooftopMapApi=this.$apiOoftopUrl;
      this.get_infos_cli();
      this.load_dossier(1);
      this.maj_partner();
    },
  };
</script>
